import { get_state, State, did_any_change } from '../../redux/State'
import { Keys } from '../../redux/Datastore'
import { Point } from '../../Point';
import { Finding, FindingCollection } from '../../Findings';
import { Id_finding, id_category_list_to_string } from '../../api/Identifiers';
import { Rectangle } from '../../Rectangle';

let _the_map: any = null;  // the map object
let _the_map_layers: any = null; // the map layers object

import { Collection, Feature, VectorLayer, VectorSource, PointGeom, Icon, Style, Projection } from '../../openlayers/ol-bridge';


let _settings: any = {
    width: 16384,
    height: 16384,
    minZoom: 0,
    maxZoom: 6,
    tileSize: 256,
    maxResolution: 16,
    minResolution: 0.25,
    initialZoom: 1,
}

_settings.extent = [0, 0, _settings.width, _settings.height]



function _includes(arr: any[], val: string | number): boolean {
    return arr.indexOf(val) > -1;
}

function _isEqual(arr_1: string[], arr_2: string[]) {
    return arr_1.length == arr_2.length && arr_1.every(function (v, i) { return v === arr_2[i] })
}

export function map_area_initialize(the_map: any, the_map_layers: any) {
    _the_map = the_map;
    _the_map_layers = the_map_layers;
    if (!_the_map_layers.findings) {
        _the_map_layers.findings = {};
    }
    _settings.projection = new Projection({
        code: 'PIXELS',
        units: 'pixels',
        extent: _settings.extent
    });
}

export function map_add_remove_finding_layer(finding_category: string, show: boolean) {
    //console.log("adding asset layer - " + assetCategory + " - " + show)

    // If the map layer already exists, detsroy it. Otherwise ghost layers can accumulate
    if (_the_map_layers.findings[finding_category]) {
        _the_map.removeLayer(_the_map_layers.findings[finding_category])
        delete _the_map_layers.findings[finding_category]
    }

    if (show) {
        let temp: FindingCollection = get_state().findings;
        temp = temp.get_findings_on_floor(get_state().id_floor);
        let findings: Finding[] = temp.get_findings_by_category_id(finding_category);//, assetCategory)
        _the_map_layers.findings[finding_category] = make_findings_layer(findings);
        _the_map.addLayer(_the_map_layers.findings[finding_category]);
    }
    // else do nothing. The layer has already been removed.

}

export function get_current_view_port_map():Rectangle{
    let num : number[] = _the_map.getView().calculateExtent(_the_map.getSize());
    let zoom : number = _the_map.getView().getZoom();
    if (zoom == 1){
        num[2] = num[2] - 8000;
    }
    else if (zoom == 2){
        num[2] = num[2] - 4000;
    }
    else if (zoom == 3){
        num[2] = num[2] - 2000;
    }
    else if (zoom == 4){
        num[2] = num[2] - 1000;
    }
    else if (zoom == 5){
        num[2] = num[2] - 500;
    }
    else if (zoom == 6){
        num[2] = num[2] - 250;
    }
    
    return Rectangle.build_from_numbers(num[0], num[1], num[2], num[3]);
}

function asset_categories(): string[] {
    return Object.keys(_the_map_layers.assets);
}

function workorder_categories(): string[] {
    return Object.keys(_the_map_layers.workorders);
}
function finding_categories(): string[] {
    return Object.keys(_the_map_layers.findings);
}



function draw_findings_layers() {
    let finding_categories_selected: string[] = id_category_list_to_string(get_state().menu_finding_categories_selected);
    Object.keys(_the_map_layers.findings).sort()
    let some_finding_layer_changed = !_isEqual(Object.keys(_the_map_layers.findings).sort(), finding_categories_selected.sort())
    if (some_finding_layer_changed) {
        // remove any layer that is in on the map, but not in the state
        Object.keys(_the_map_layers.findings).forEach((finding_category_id: string) => {
            if (!_includes(finding_categories_selected, finding_category_id)) {
                map_add_remove_finding_layer(finding_category_id, false)
            }
        });
        // add any layer that is in the state, but not on the map
        finding_categories_selected.forEach((finding_category_id: string) => {
            if (!_includes(Object.keys(_the_map_layers.findings), finding_category_id)) {
                map_add_remove_finding_layer(finding_category_id, true)
            }
        });
    }

}

`
This function ensures that the assets and workorders that are displayed on the
map match the assets and workorders that are marked as selected in the state.
`
export function map_redraw_layers(force_reload?: boolean) {
    // awh todo - relocate the content of the map_redraw_layers function in cms_view_view here.
    if (force_reload === undefined) {
        force_reload = false
    }



    if (did_any_change([Keys.DATA_ASSETS,
    Keys.KEY_DATA_ALL_ATTACHMENTS,
    Keys.DATA_WORKORDERS,
    Keys.DATA_FINDINGS,
    Keys.ID_DRAWING])) {
        force_reload = true;
    }

    if (force_reload) {

        // If a reload is being forced, simply remove and destroy all asset, 
        // workorder, attachments, and findings layers from the map. They will 
        // be re-created by the repaint routine.

        // let feature_categories = Object.keys(_the_map_layers.assets)
        // _.forEach(asset_categories, function (asset_category) {
        //     map.removeLayer(_the_map_layers.assets[asset_category])
        //     delete _the_map_layers.assets[asset_category]
        // })

        // workorder_categories = Object.keys(_the_map_layers.workorders)
        // _.forEach(workorder_categories, function (workorder_category) {
        //     map.removeLayer(_the_map_layers.workorders[workorder_category])
        //     delete _the_map_layers.workorders[workorder_category]
        // })

        // remove the findings layers
        finding_categories().forEach((finding_category: string) => {
            _the_map.removeLayer(_the_map_layers.findings[finding_category])
            delete _the_map_layers.findings[finding_category]
        })
        // remove the attachments layer
        // _the_map.removeLayer(_the_map_layers.attachments)
        // delete _the_map_layers.attachments
    }

    draw_findings_layers();


}

/*
*  map_redraw_layers() -> map_add_remove_asset_layer()-> mapMakeAssetsLayer()
*/
function make_findings_layer(findings: Finding[]) {
    let asset_features = new Collection<Feature>();
    let p0: Point = get_state().drawing_p0;

    findings.forEach((finding: Finding) => {
        var feat = create_finding_feature(finding, p0);
        asset_features.push(feat);
    });

    let asset_layer = new VectorLayer({
        source: new VectorSource({
            features: asset_features,
            wrapX: false,
        })
    });
    return asset_layer;
}



function create_feature(point: Point) {
    let pt = new PointGeom([point.X, point.Y]);
    let feature = new Feature({ geometry: pt });
    return feature;
}


function create_finding_feature(finding: Finding, p0: Point) {
    let iconImg = new Icon({
        anchor: [.5, .5],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        src: finding.icon
    });
    let iconStyle = new Style({ image: iconImg });
    let id_finding = finding.id.toString();
    let coords: Point = finding.adj_coord;
    if (!coords) {
        coords = p0;
    }
    let feature = create_feature(coords);
    feature.setId(finding.id.toString());
    feature.setStyle(iconStyle);
    feature.set('data', finding.toJSON());
    feature.set('feature', "finding");
    feature.set('raw', finding.raw);
    return feature;
}



export function map_area_on_click(e: any) {


    let state: State = get_state();
    if (state.get_boolean(Keys.STATE_CREATING_ASSET) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }
    if (state.get_boolean(Keys.STATE_CREATING_WORKORDER) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }

    //if (state.get_boolean(Keys.KEY_STATE_IS_PAGE_CURRENTLY_SITEMAP) {
    //     openUrl(e.pixel, map);
    //}
    let feature: any = _the_map.forEachFeatureAtPixel(e.pixel, function (feature: any, layer: any) {
        if (feature.values_.data !== undefined) {
            return feature
        }
    })

    if (!feature) {
        return;  // no feature was found
    }

    // All featured that can be opened up and edited contain a data field.
    if (feature.values_.data) {
        var data = feature.values_.data;
        var feature_type = feature.values_.feature;
        if (!feature_type) {
            console.error("the map feature.values_.feature field is missing the required feature field")
        }

        // if (feature_type === "asset") {
        //     var id_asset = data.id_asset;
        //     var raw_asset = get_raw_asset(state, id_asset);
        //     parent.postMessage(raw_asset, '*');
        //     if (is_debug_enabled(state)) {
        //         jsonLog(raw_asset);
        //     }
        //     return;
        // }

        if (feature_type === "finding") {
            var id_finding = data.id_finding;
            var finding: Finding = get_state().findings.get_finding(Id_finding.wrap(id_finding));
            parent.postMessage(finding.raw, '*');
            if (get_state().is_debug) {
                console.error(JSON.stringify(finding.raw, null, 2));
            }
            return;
        }

        // if (feature_type === "attachment") {
        //     var coordinate = e.coordinate;
        //     var id_attachment = data.id_attachment
        //     var drawing_p1p2 = state.get(KEY_DRAWING_P1P2);
        //     ui_attachments__attachment_clicked(state, coordinate, data, data.reposition_icon, dispatch);
        //     __temp_update_attachment = {};
        //     __temp_update_attachment.url = data.url;
        //     __temp_update_attachment.original_coords = data.coords;
        //     return;
        // }

        // if (feature_type === "workorder") {
        //     // open the edit form for the work order
        //     var raw = get_raw_workorder(state, data.id);
        //     parent.postMessage(raw, '*');
        //     // if (getState().debug_enabled) {
        //     jsonLog(raw);
        //     // }
        //     return;
        // }
        console.error("the selected map feature is not an asset or a work order")
        return;
    }
    else {
        console.error("feature doesn't have a raw CMS data")
    }




}


// WEBPACK FOOTER //
// ./src/ts/ui/map/map_area.ts